
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import authQueries from "../src/queries/authQueries";
import './App.css';
import 'typeface-public-sans';
import ReviewForm from './ReviewForm';
import FeedbackForm from './FeedbackForm';
import ThankyouForm from './ThankyouForm';

const HomePage = () => {
  const [propertyId, setPropertyId] = useState(''); 
  const [errorMessage, setErrorMessage] = useState('');
  useEffect(() => {
    setPropertyId(propertyId);
  }, [propertyId]);

  const generateRandomValue = (length) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let randomString = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      randomString += characters[randomIndex];
    }
    return randomString;
  };

  const handleClick = async () => {
    const origin = 'QR';
    const bookingId = generateRandomValue(8);
    const guestName = generateRandomValue(10);
    const source = generateRandomValue(8);
  
    const url = `/review?origin=${origin}&propertyId=${propertyId}&booking_id=${bookingId}&guestName=${guestName}&source=${source}`;
    try {
      const response = await getProperty.mutateAsync({
        propertyId: propertyId,
      });
  
      const propertyName = response.info.propertyName;
      const publicReviewUrl = response.info.publicReviewUrl;
  
      localStorage.setItem('propertyId', propertyId);
      localStorage.setItem('bookingId', bookingId);
      localStorage.setItem('guestName', guestName);
      localStorage.setItem('source', source);
      localStorage.setItem('propertyName', propertyName);
      localStorage.setItem('publicReviewUrl', publicReviewUrl);
  
      window.location.href = url;
    } catch (error) {
      console.log("Errors occurred during the API call");
      setErrorMessage('Please check the entered propertyId');
    }
  };

  const getProperty = authQueries.useGetProperty(propertyId, (response) => {
  if (response) {

      console.log("Response====" + response);
      const propertyName = response.info.propertyName;
      const publicReviewUrl = response.info.publicReviewUrl;
      localStorage.setItem('propertyName', propertyName);
      localStorage.setItem('publicReviewUrl', publicReviewUrl);
  }else {
      console.log("No data found");
  }
  });

  return (
    <div >
      <h1>Property Review</h1>
      <h2>Home Page</h2>
      {errorMessage && <p style={{color:'red',fontSize:'bold'}}>{errorMessage}</p>}
      <div className="form-group">
            <input
              className="textbox"
              type="text"
              id="propertyId"
              value={propertyId}
              onChange={(e) => setPropertyId(e.target.value)}
              placeholder="Enter PropertyId"
            />
          </div>
      <Link to="#" onClick={handleClick}>
        Click for Review
      </Link>
    </div>
  );
};

const App = () => {
  return (
      <div className="App page-wrapper">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/review" element={<ReviewFormPage />} />
          <Route path="/feedback-form" element={<FeedbackFormPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
        </Routes>
      </div>
  );
};

const ReviewFormPage = () => {
  return (
    <div className='parent-reviews parent-reviews-rating'>
      <ReviewForm />
    </div>
  );
};

const FeedbackFormPage = () => {
  return (
    <div className='parent-reviews parent-feedback-form'>
      <FeedbackForm />
    </div>
  );
};

const ThankYouPage = () => {
  return (
    <div className='parent-reviews'>
     <ThankyouForm />
    </div>
  );
};

export default App;
